import { combineReducers } from 'redux';

import rols from './rols';
import tots from './tots';
import formulari from './formulari';
import peticioUsuarisEnCurs from './peticioUsuarisEnCurs';
import peticioRolsEnCurs from './peticioRolsEnCurs';

export default combineReducers({
    rols,
    tots,
    formulari,
    peticioUsuarisEnCurs,
    peticioRolsEnCurs
});



// WEBPACK FOOTER //
// ./src/reducers/usuari/index.js